import { render, staticRenderFns } from "./OsAppUsersCampaigns.vue?vue&type=template&id=27f961dc&scoped=true"
import script from "./OsAppUsersCampaigns.vue?vue&type=script&lang=ts"
export * from "./OsAppUsersCampaigns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f961dc",
  null
  
)

export default component.exports